import React, { ReactNode } from 'react';
import iconLoader from '../../assets/icons/icons_loader.svg';
import MiniLoader from '../MiniLoader';

interface ButtonProps {
  /**
   * How large should the button be?
   */
  size: 'small' | 'medium' | 'large';
  /**
   * Button contents
   */
  label: ReactNode;
  /**
   * Optional click handler
   */
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  /**
   * Custom Classes
   */
  classes?: string;

  type: 'primary' | 'secondary' | 'passive' | 'disabled' | 'warning',

  loading?: boolean,
}

export const ButtonLoader: React.FC = () => (<img className="animate-spin" src={iconLoader} alt="loading" />);

/**
 * Primary UI component for user interaction
 */
// eslint-disable-next-line react/prefer-stateless-function
export class Button extends React.Component<ButtonProps> {
  render() {
    const {
      type,
      size,
      label,
      classes,
      loading = false,
    } = this.props;
    const color = size === 'medium' ? 'font-bold' : 'font-bold';
    let mode: string;
    switch (type) {
      case 'primary': mode = 'bg-gojek-green text-white'; break;
      case 'secondary': mode = 'bg-white text-gojek-green border border-gojek-green'; break;
      case 'passive': mode = 'bg-light-active-secondary text-gojek-green border border-transparent'; break;
      case 'disabled': mode = 'bg-[#bbbbbb] text-white'; break;
      case 'warning': mode = 'text-custom-warning border-custom-warning border'; break;
      default: mode = 'bg-white text-gojek-green border border-gojek-green'; break;
    }
    const spacing = size === 'medium' ? 'px-4 py-3' : 'px-4 py-2';
    const fontSize = size === 'medium' ? 'text-base' : 'text-sm';
    const { props } = this;
    return (
      <button
        disabled={type === 'disabled' || loading}
        type="button"
        className={['rounded-3xl', spacing, color, 'font-bold', fontSize, mode, classes].join(' ')}
        onClick={(e) => {
          if (props.onClick) props.onClick(e);
        }}
      >
        <MiniLoader loading={loading} loader={ButtonLoader}>{label}</MiniLoader>
      </button>
    );
  }
}

export default Button;
